import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { API } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const finish = () => navigate(pathname || "/", { replace: true });

    if (!sessionId) {
      finish();
      return;
    }

    (async () => {
      try {
        const r = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            session_id: sessionId,
            ref_code: localStorage.getItem("spur_ref") || null,
          }),
        });
        if (!r.ok) throw new Error("exchange failed");
        const user = await r.json();
        setUser(user);
        toast.success(`Signed in as ${user.name || user.email}`);
      } catch {
        toast.error("Sign-in failed. Please try again.");
      } finally {
        finish();
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e2e2e2] animate-pulse">
        Signing you in…
      </div>
    </div>
  );
}
